// timeFormatter.js

// Function to format a timestamp string into a readable time string
function formatTimestamp(timestampString) {
  const date = new Date(timestampString);

  // Get the time in 12-hour format with AM/PM
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12:xx AM/PM

  return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
}

function formatHour(number) {
  if (number >= 0 && number <= 9) {
    return `0${number}:00`;
  } else if (number >= 10 && number <= 23) {
    return `${number}:00`;
  } else {
    return 'Invalid input';
  }
}

function parseTime(dateString) {
  // Extract the part after 'T' and before the first '+'
  const timePart = dateString.split('T')[1].split('+')[0];
  const hour = timePart.split(':')[0];
  const minute = timePart.split(':')[1];

  return `${hour}:${minute}`;
}

// calendar functions / variables

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function getMonthString(monthNumber) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return monthNames[monthNumber];
}

function calculatePercentage(total, number) {
  if (
    total == undefined ||
    total == null ||
    number == undefined ||
    number == null
  ) {
    return 0;
  }
  return Math.round((number / total) * 100);
}

const generateYearsList = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 2022; year <= currentYear; year++) {
    years.push(year);
  }
  return years;
};

const dateToDateString = (date) => {
  return date.toISOString().split("T")[0];
};

//#region calendar tile functions
function isPastDate(dateStr) {
  // Handle array input (from .split("T"))
  const dateInput = Array.isArray(dateStr) ? dateStr[0] : dateStr;
  
  // Extract date string (handles "2026-03-04T00:00:00.000Z" or "2026-03-04")
  const dateOnly = dateInput.split('T')[0];
  
  // Parse the date parts directly from string to avoid timezone issues
  const [year, month, day] = dateOnly.split('-').map(Number);
  
  // Create date at local midnight for input date
  const inputDate = new Date(year, month - 1, day); // month is 0-indexed in Date constructor
  
  // Get current date at local midnight
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  
  // Compare
  return inputDate < currentDate;
}

// returns if target date is in the past or tomorrow
function isInPastOrOneDayInFuture(targetDate) {
  const now = new Date();
  const oneDayInMs = 24 * 60 * 60 * 1000;
  const difference = targetDate - now;
  return difference <= -oneDayInMs;
}

function isToday(dateStr) {
  // Handle array input (from .split("T"))
  const dateInput = Array.isArray(dateStr) ? dateStr[0] : dateStr;
  
  // Extract date string (handles "2026-03-04T00:00:00.000Z" or "2026-03-04")
  const dateOnly = dateInput.split('T')[0];
  
  // Parse the date parts directly from string to avoid timezone issues
  const [year, month, day] = dateOnly.split('-').map(Number);
  
  // Get current local date parts
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // getMonth() is 0-indexed
  const currentDay = now.getDate();
  
  // Compare year, month, and day directly
  return year === currentYear && month === currentMonth && day === currentDay;
}


//#endregion

// Export the function for use in other modules
module.exports = {
  formatTimestamp,
  formatHour,
  parseTime,
  days,
  months,
  getMonthString,
  calculatePercentage,
  generateYearsList,
  dateToDateString,
  isPastDate,
  isInPastOrOneDayInFuture,
  isToday
}
